// Componente Angular para la gestión de vacaciones de los empleados asociados con un usuario.
// Se importa en vacaciones.module.ts

import { Component, OnInit } from "@angular/core";
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from "@angular/router";
import { EmployeesListService } from "../employees-list.service";
import { Observable } from "rxjs";
import { EmployeesListModel } from "../employees-list.model";

import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { EMPLOYEES_ROUTES } from "../const";
import { consts } from "../../../consts";
import { Utils } from "../../../shared/utils";
import { DummyComponent } from "../../../shared/dummy.component";
import { AsuntosPropios } from "../../../models/personal/asuntos-propios.models";
import { AsuntosPropiosService } from "../../../services/employees/asuntos-propios.service";
import { AsuntosPropiosFormComponent } from "./asuntos-propios-form.component";

@Component({
    selector: "app-asuntos-propios",
    templateUrl: "./asuntos-propios.component.html",
    styleUrls: ["./asuntos-propios.component.css"],
    standalone: false
})
export class AsuntosPropiosComponent implements OnInit {
    // #region Propiedades del componente
    empleados: EmployeesListModel[] = [];
    displayedColumns: string[] = [
        "employee",
        "cadenaInicio",
        "cadenaFin",
        "motivo",
        "cadenaFechaSolicitud",
        "acciones",
    ];
    displayedColumnsByEmployee: string[] = [
        "cadenaInicio",
        "cadenaFin",
        "motivo",
        "cadenaFechaSolicitud",
        "nombreEstado",
    ];
    row: AsuntosPropios = null;
    asuntosPropiosAprobados$: Observable<AsuntosPropios[]> =
        this.AsuntosPropiosService.asuntosPropiosAprobados$;
    asuntosPropiosSolicitados$: Observable<AsuntosPropios[]> =
        this.AsuntosPropiosService.asuntosPropiosSolicitados$;
    asuntosPropios: AsuntosPropios = null;
    asuntosPropiosPorEmpleado: AsuntosPropios[] = null;
    routes: object[] = [];

    formBusqueda: UntypedFormGroup = null;
    // #endregion

    constructor(
        private router: Router,
        public dialog: MatDialog,
        public dummyComponent: DummyComponent,
        public EmployeesListService: EmployeesListService,
        public AsuntosPropiosService: AsuntosPropiosService,
        protected snackBar: MatSnackBar
    ) {
        this.routes = EMPLOYEES_ROUTES;
    }

    cancelar(): void {
        if (this.formBusqueda != null) {
            this.formBusqueda.reset();
        }

        this.asuntosPropiosPorEmpleado = [];
    }

    create(): void {
        if (!Utils.IsTierFour()) {
            this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
                duration: 3000,
            });
            return;
        }

        const dialogRef = this.dialog.open(AsuntosPropiosFormComponent, {
            width: "90%",
            maxWidth: "900px",
            maxHeight: "90vh",
            data: { empleados: this.empleados, asuntosPropios: null },
        });
        dialogRef.afterClosed().subscribe((result) => {
            this.dummyComponent.redirectTo(this.router.url);
        });
    }

    editar(): void {
        if (!Utils.IsTierFour()) {
            this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
                duration: 3000,
            });
            return;
        }

        const dialogRef = this.dialog.open(AsuntosPropiosFormComponent, {
            width: "90%",
            maxWidth: "900px",
            maxHeight: "90vh",
            data: { asuntosPropios: this.row, empleados: this.empleados },
        });
        dialogRef.afterClosed().subscribe((result) => {
            this.dummyComponent.redirectTo(this.router.url);
        });
    }

    eliminar(): void {
        if (!Utils.IsTierFour()) {
            this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
                duration: 3000,
            });
            return;
        }

        this.AsuntosPropiosService.deleteAsuntosPropios(this.row.id).subscribe({
            next: (resultado) => {
                if (resultado) {
                    this.dummyComponent.redirectTo(this.router.url);
                }
            },
        });
    }

    ngOnInit() {
        // Obtención de los empleados ...
        this.EmployeesListService.getList(true).then((data) => {
            this.empleados = data;
            this.inicializarFormulario();

            // ... y carga de las vacaciones
            this.AsuntosPropiosService.getAsuntosPropios();
        });
    }

    nombreEmpleado(uid: number): string {
        const empleado = this.empleados.find((e) => e.uid == uid);
        return empleado ? empleado.name : "";
    }

    obtenerAsuntosPropiosPorEmpleado(): void {
        if (this.formBusqueda.valid) {
            this.asuntosPropiosPorEmpleado = [];

            this.AsuntosPropiosService.getAsuntosPropiosPorEmpleado(
                this.formBusqueda.value.employees_Id
            ).subscribe({
                next: (resultado) => {
                    if (resultado) {
                        this.asuntosPropiosPorEmpleado = resultado;
                    }
                },
            });
        }
    }

    setRow(row: AsuntosPropios): void {
        this.row = row;
    }

    private inicializarFormulario() {
        this.formBusqueda = new UntypedFormGroup({
            employees_Id: new UntypedFormControl(undefined, [Validators.required]),
        });
    }
  public trackByIndex(i: number) { return i; }

}
